export const goToMailCommand = "R5yQJe";
export const goToCalendarCommand = "uX84cc";
export const goToHostedAppCommand = "kpQJYc";
export const goToPreviousViewCommand = "_0cL8c";
export const goToNextViewCommand = "ot47Xb";
export const goToDevToolsCommand = "wIiz0b";
export const goToEdgeTracingToolsCommand = "ogdjxb";
export const jumpFocus = "CL$_Nd";
export default {goToMailCommand,goToCalendarCommand,goToHostedAppCommand,goToPreviousViewCommand,goToNextViewCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand,jumpFocus};